import { type Table } from '@tanstack/react-table'
import { type PartialKeys, type VirtualizerOptions, useVirtualizer } from '@tanstack/react-virtual'
import { useRef } from 'react'

import { DataTableBase, type DataTableBaseProps } from './DataTableBase'

export interface DataTableVirtualizedProps<TData = unknown> extends DataTableBaseProps<TData> {
  table: Table<TData>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  virtualization: PartialKeys<VirtualizerOptions<any, Element>, 'observeElementRect' | 'observeElementOffset' | 'scrollToFn' | 'count' | 'getScrollElement'>
}

export const DataTableVirtualized = <TData, >(props: DataTableVirtualizedProps<TData>) => {
  const { table, virtualization, ...rest } = props
  const containerRef = useRef<HTMLDivElement>(null)

  const { rows } = table.getRowModel()
  const rowVirtualizer = useVirtualizer({
    count: rows.length,
    getScrollElement: () => containerRef.current,
    /**
     * measure dynamic row height, except in firefox because it measures table border height incorrectly
     */
    measureElement:
      typeof window !== 'undefined'
      && !navigator.userAgent.includes('Firefox')
        ? element => element?.getBoundingClientRect().height
        : undefined,
    overscan: 5,
    ...virtualization,
  })
  return (
    <DataTableBase containerRef={containerRef} table={table} rowVirtualizer={rowVirtualizer} {...rest} />
  )
}
